// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2Y8Ze","header":"PatientBlock_header__hpyF2","label":"PatientBlock_label__3iTb6","option":"PatientBlock_option__1U83T"};